import { Component, Input } from '@angular/core';
import { NgClass, SlicePipe } from '@angular/common';
import { ASSET_CONSTANTS } from '../../../shared/constants/asset-constants';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-mb-announcement',
  templateUrl: 'mb-announcement.component.html',
  imports: [NgClass, SlicePipe, DatePipe],
})
export class MbAnnouncementComponent {
  @Input() author!: string;
  @Input() date!: string;
  @Input() title!: string;
  @Input() content!: string;
  @Input() logoUrl: string | null = null;

  isExpanded = false;

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
  }

  protected readonly ASSET_CONSTANTS = ASSET_CONSTANTS;

  onWhatsappShare(): void {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      `*Mbaza Announcements*: ${this.content}`
    )}`;
    window.open(whatsappUrl, '_blank');
  }
}
